import React from "react";
import { LOCAL_STORAGE_LANGUAGE } from "@utils/api-requests/static-data";
import { useIntl } from "react-intl";
import styled from "@emotion/styled";
import { mq } from "@utils/media-query/mediaQuery";
import {
  FourItems,
  InspireMembershipSection,
  SixItems,
  ThreeItems,
  ThreeItemsWithDescription,
  WelcomeSection,
} from "@components/events/event-templates";
import {
  FIFTH_SECTION_CONTENTS,
  FOURTH_SECTION_CONTENTS,
  SECOND_SECTION_CONTENTS,
  SIXTH_SECTION_CONTENTS,
  THIRD_SECTION_CONTENTS,
  WELCOME_SECTION_CONTENTS,
} from "@components/events/inspire-your-summer/InspireYourSummerContents";
import SummerBannerImage from "@components/events/inspire-your-summer/SummerBannerImage";

const Container = styled.div(({ theme, isJapanese, url }) => ({
  backgroundImage: `url(${url})`,
  width: "100%",
  maxWidth: "144rem",
  margin: "0 auto",
  fontFamily: theme.fontFamily.primaryFont,
  wordWrap: "break-word",
  wordBreak: "keep-all",
  whiteSpace: "break-spaces",

  "@media (min-width: 1200px) and (max-width: 1440px)": {
    maxWidth: "120rem",
  },
}));

const Wrapper = styled.div(() => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem 0",

  padding: "1.5rem 1.5rem 6.2rem 1.5rem",

  [mq("tablet")]: {
    gap: "3rem 0",
    padding: "4.4rem 4.4rem 6.2rem 4.4rem",
  },

  [mq("desktop")]: {
    gap: "5rem 0",
    padding: "7.5rem 7.5rem 11rem 7.5rem",
  },

  "@media (min-width: 1200px) and (max-width: 1440px)": {
    gap: "4.2rem 0",
    padding: "4.4rem 4.4rem",
  },
}));

export const SUMMER_AWS_BUCKET_URL =
  "https://inspireweb-assets.s3.ap-northeast-2.amazonaws.com/microsite/inspire-your-summer";

const InspireYourSummer = () => {
  const lang = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  const intl = useIntl();
  const intlFormat = (id) => {
    return intl.formatMessage({
      id: id,
    });
  };

  return (
    <Container
      isJapanese={lang === "ja"}
      url={`${SUMMER_AWS_BUCKET_URL}/background.jpg`}
    >
      <SummerBannerImage />

      <Wrapper>
        {/* INSPIRE Your Summer */}
        <WelcomeSection
          intlFormat={intlFormat}
          contents={WELCOME_SECTION_CONTENTS}
        />

        {/* Special Room Offers */}
        <FourItems intlFormat={intlFormat} contents={SECOND_SECTION_CONTENTS} />

        {/* Dive into Summer at Splash Bay */}
        <ThreeItems intlFormat={intlFormat} contents={THIRD_SECTION_CONTENTS} />

        {/* Endless Culinary Journey */}
        <ThreeItemsWithDescription
          intlFormat={intlFormat}
          contents={FOURTH_SECTION_CONTENTS}
          id={5}
        />

        {/* Special Events */}
        <ThreeItemsWithDescription
          intlFormat={intlFormat}
          contents={FIFTH_SECTION_CONTENTS}
          id={6}
        />

        {/* Arena Performances */}
        <SixItems intlFormat={intlFormat} contents={SIXTH_SECTION_CONTENTS} />

        {/* INSPIRE MEMBERSHIP */}
        <InspireMembershipSection intlFormat={intlFormat} />
      </Wrapper>
    </Container>
  );
};

export default InspireYourSummer;
